<template>
  <div class="pub-all-status">
    <span class="s-icon">
      <a-icon
        :type="icon[iconIndex]"
        v-if="icon.length"
        :style="{ color: colors[iconIndex] }"
      />
    </span>
    <span class="s-text">{{ text }}</span>
  </div>
</template>

<script>
// 页面使用
// <PubStatus
//   :status="record.status" // 接口返回值
//   type="PROJECT_STATUS" // 字典值
//   :icon="['history', 'check-circle', 'history', 'check-circle']" // 为空不显示图标，有的话要和字段数量对应，否则不显示
//   :colors="['#ff0000', '#ffcc36', '#ffcc36', '#ffcc36']"
// />
import { mapState } from "vuex";
export default {
  name: "PubStatus",
  computed: {
    ...mapState("setting", ["allSysCode"]),
  },
  watch: {
    type: {
      handler() {
        this.getText();
      },
    },
    status: {
      handler() {
        this.getText();
      },
    },
    allSysCode: {
      //深度监听，可监听到对象、数组的变化
      handler() {
        this.getText();
      },
      deep: true, //true 深度监听
    },
  },
  mounted() {
    this.getText();
  },
  data() {
    return {
      iconIndex: 0,
      text: "",
    };
  },
  props: {
    status: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    icon: {
      type: Array,
      default: () => [],
    },
    colors: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getText() {
      if (JSON.stringify(this.allSysCode) !== "{}" && this.type) {
        const aa = this.allSysCode[this.type]
          ? this.allSysCode[this.type].find((v, index) => {
              this.iconIndex = index;
              return v.value == this.status;
            })
          : {};
        this.text = aa ? aa.label : "";
      } else {
        this.text = "";
      }
    },
  },
};
</script>

<style scoped lang="less">
.pub-all-status {
  .s-icon {
    margin-right: 5px;
    position: relative;
    top: 1px;
  }
  .s-text {
  }
}
</style>
